/* NP 7.9 (4/10): variantbilledet i anbefalingerne hentes i 200 px (vises 77 px). */
/*
  NordiskPuls - "Vi anbefaler ogsaa": billede og pris fulgte ikke valget
  =================================================================
  Upsell-boksen i cart-drawer.liquid renderer <select name="id"> med alle
  varianter, men der er ingen handler paa den. Resultatet:
    - billedet bliver staaende paa produktets standardbillede
    - prisen bliver staaende paa product.price, som er den LAVESTE

  Det sidste er det alvorlige: Bambus Lagen gaar 395-449 og KomfortTopper
  1245-1845, saa kunden ser den billigste pris uanset hvilken stoerrelse
  han vaelger, og bliver trukket en anden i checkout.

  Ligger i sin egen fil frem for i np-cart-farvevaelger.js, fordi det er et
  selvstaendigt problem der intet har med farvevaelgeren at goere.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var cache = {};
  function hentProdukt(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  // Samme formatering som temaets egen upsell-kode bruger
  function formatKr(oere) {
    return (oere / 100).toLocaleString('da-DK', {
      style: 'currency', currency: 'DKK', minimumFractionDigits: 0
    }).replace(',00', '').replace('kr.', 'kr');
  }

  function opdater(select) {
    var boks = select.closest('.upsell-product');
    if (!boks) return;
    var link = boks.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = link.getAttribute('href').split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    var valgtId = parseInt(select.value, 10);
    if (!valgtId) return;

    hentProdukt(handle).then(function (p) {
      if (!p) return;
      var v = p.variants.find(function (x) { return x.id === valgtId; });
      if (!v) return;

      var img = boks.querySelector('img');
      var billede = (v.featured_image && v.featured_image.src) || p.featured_image;
      if (img && billede) img.src = billede + (String(billede).indexOf('?') > -1 ? '&' : '?') + 'width=200';

      var pris = boks.querySelector('.upsell-price');
      if (pris) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s style="color: #888; font-size: 1.05rem; margin-right: 4px;">'
                + formatKr(v.compare_at_price) + '</s> ';
        }
        html += formatKr(v.price);
        pris.innerHTML = html;
      }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('upsell-variant-select')) opdater(t);
  });

  // Ogsaa ved foerste visning: den forvalgte variant er ikke noedvendigvis
  // den som product.price stammer fra.
  function synkroniser() {
    document.querySelectorAll('.upsell-variant-select').forEach(opdater);
  }

  var timer = null;
  function planlaeg() { clearTimeout(timer); timer = setTimeout(synkroniser, 80); }

  planlaeg();
  document.addEventListener('cart:updated', planlaeg);
  document.addEventListener('DOMContentLoaded', planlaeg);
  var drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(planlaeg).observe(drawer, { childList: true, subtree: true });
})();
